import { Autocomplete, GridLegacy as Grid, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useOrgTree } from '~/data/orgunits';
import { Form } from '~/features/RehireDialog/hooks/useRehireEmpForm';
import { useSxStyles } from '~/features/RehireDialog/useStyles';

type Props = {
  control: Control<Form>;
};

type BusinessUnitNames =
  | 'rehire.employment.fEmpBusinessUnit2'
  | 'rehire.employment.fEmpBusinessUnit3';

export const BusinessUnitComponent = ({ control }: Props) => {
  const { orgTree } = useOrgTree();
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const requiredText = t('fieldIsRequired');

  return (
    <>
      {/* INFO: The first is the main org tree, that falls under UNIT not business unit */}
      {orgTree.slice(1).map((bu) => {
        const name =
          `rehire.employment.fEmpBusinessUnit${bu.fTreeId}` as BusinessUnitNames;
        return (
          <Grid item key={bu.fTreeId} container>
            <Controller
              control={control}
              rules={bu.fTreeId === 1 ? { required: requiredText } : undefined}
              name={name}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Autocomplete
                  options={bu.units}
                  getOptionLabel={(o) => o.fTreeUnitName}
                  isOptionEqualToValue={(o, v) =>
                    o.fTreeUnitId === v.fTreeUnitId
                  }
                  onChange={(_, value) => onChange(value?.fTreeUnitId ?? '-1')}
                  value={bu.units.find((o) => o.fTreeUnitId === value) || null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required={bu.fTreeId === 1 || false}
                      label={bu.fTreeName}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                  sx={{
                    ...sxStyles.selectStyle,
                    ...sxStyles.inputBottomMargin,
                  }}
                />
              )}
            />
          </Grid>
        );
      })}
    </>
  );
};
